/* istanbul ignore file */
import { GeneralResourceDetail, MpxItemResponse, UserResourceDetailsQueryParams } from '../types'
import { generatePath } from '../utils'
import { DetailsResponse } from './types'
import { getMpAgent } from './utils'

const agent = getMpAgent()

const PATHS = {
  DETAIL: '/user-data-details/:userId',
}

export class UserDetailsAPI {
  static get<T extends GeneralResourceDetail = GeneralResourceDetail>({
    resourceId,
  }: {
    resourceId: string
  }) {
    return agent
      .get<DetailsResponse<T>>(generatePath(PATHS.DETAIL, { resourceId }))
      .then(response => response?.data)
  }

  static update({ userId, details }: UserResourceDetailsQueryParams) {
    return agent
      .patch<MpxItemResponse<GeneralResourceDetail>>(generatePath(PATHS.DETAIL, { userId }), {
        details,
      })
      .then(response => response?.data)
  }

  //delete by nulling out the result block
  static delete({ userId, details }: UserResourceDetailsQueryParams) {
    return agent
      .patch<MpxItemResponse<GeneralResourceDetail>>(generatePath(PATHS.DETAIL, { userId }), {
        details: details.map(({ traitId, year }) => ({ traitId, year })),
      })
      .then(response => response?.data)
  }
}
